import React, { Component } from 'react'
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

class DropdownIncremental extends Component{
    constructor(props){
        super(props)
        this.state = {
            answer: ""
        }
    }

    componentDidMount(){
        if(this.props.question.Responses[0].Response.length){
            this.setState({
                answer: this.props.questions.Responses[0].Response
            })
        }
    }

    changeAnswer = (ev) => {
        console.log("dropdown answer: ", ev.target.value)
        this.setState({
            answer: ev.target.value
        })
        this.props.updateResponseValue(ev.target.value)
    }
    render(){
        if(this.props){
            let answer = this.props.question.Responses[0].Response;
            console.log("Dropdown answer: " + answer)

            var answers = []
            var value;
            value = parseInt(this.props.question.ValueLimitationMin)
            while(value <= parseInt(this.props.question.ValueLimitationMax)){
                answers.push(<MenuItem style={{whiteSpace: 'normal'}} value={value}>{value}</MenuItem>)
                value += parseInt(this.props.question.ValueLimitationIncrement)
            }
            return(
                //<Radio>Answer</Radio>

                <FormControl variant="outlined" style={{minWidth:'120'}}>
                    <InputLabel id="dropdown-label"></InputLabel>
                    <Select
                      labelId={"dropdown-label"}
                      label="Please Select"
                      value={this.state.answer}
                      labelWidth={120}
                      onChange={this.changeAnswer}
                    >
                    {answers}
                    </Select>
                </FormControl>
            )
        } else return <p>nope</p> 
        
    }
}

export default DropdownIncremental;